import { RefObject, useEffect } from 'react';

function getElement(event: MouseEvent): HTMLElement | null {
  return event.target instanceof HTMLElement ? event.target : null;
}

export const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
  // If the element is in the allowList, such as the waterfall control buttons,
  // clicking them will not trigger the callback
  allowList?: string[]
) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        const element = getElement(event);

        const isMatch =
          !allowList?.length ||
          (element && allowList.some((v) => !element?.matches(v)));

        if (isMatch) {
          callback();
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [allowList, callback, ref]);
};
